<template>
  <div>
    <div class="question-box-intro-two"><h3>Details</h3></div>
    <CashText
        v-model="form.text"
        :index="index"
        :noSave="noSave"
        :errorsPost="errorsPost.text"
        :amount="form.amount"
        :location="location"
        ref="cashText"
        :id="`${location}${index}text`"
    />

    <CashAmount
        v-model="form.amount"
        @input="$refs.cashText.setText()"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.amount"
        :location="location"
        :id="`${location}${index}amount`"
    />

    <IndexedYN
        v-model="form.indexed"
        :index="index"
        :gift-details="form"
        :no-save="noSave"
        :errors-post="errorsPost.indexed"
        :location="location"
        :id="`${location}${index}indexed`"
    />

    <TaxYN
        v-model="form.taxFree"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.taxFree"
        :location="location"
        :id="`${location}${index}taxFreee`"
    />

    <ConditionYN
        v-model="form.conditionYN"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.conditionYN"
        :location="location"
        :id="`${location}${index}conditionYN`"
    />

    <Condition
        v-if="form.conditionYN"
        v-model="form.condition"
        :index="index"
        :no-save="noSave"
        :errors-post="errorsPost.condition"
        :location="location"
        :id="`${location}${index}condition`"
    />

    <Recipients
        v-model="form.recipients"
        :options-data="primaryOptions"
        :index="index"
        :no-save="noSave"
        :location="location"
        :errors-post="errorsPost.recipients"
        :id="`${location}${index}recipients`"
    />

    <ShareType
        v-if="recipientsMoreThanOne"
        v-model="form.shareType"
        :index="index"
        :no-save="noSave"
        :location="location"
        :gift-details="form"
        type-location="shareType"
        :id="`${location}${index}shareType`"
    />

    <ShareSeparatePercentages
        v-if="form.shareType === 'separate'"
        v-model="form.recipients"
        :index="index"
        :no-save="noSave"
        :location="location"
        :gift-details="form"
        shareLocation="recipients"
    />

    <div v-if="showPerStirpesOptions">
      <StirpesYN
          v-model="form.stirpes"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpes"
          :gift-details="form"
          :location="location"
          :id="`${location}${index}stirpes`"
      />
      <StirpesAge
          v-if="form.stirpes"
          v-model="form.stirpesAge"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.stirpesAge"
          :location="location"
          :id="`${location}${index}stirpesAge`"
      />
    </div>

    <div v-show="showBackupOptions">
      <RecipientsBackupYN
          v-model="form.backupRecipientsYN"
          :index="index"
          :no-save="noSave"
          :errors-post="errorsPost.backupRecipientsYN"
          :gift-details="form"
          :location="location"
          :id="`${location}${index}backupRecipientsYN`"
      />
      <RecipientsBackup
          v-if="form.backupRecipientsYN"
          v-model="form.backupRecipients"
          :options-data="secondaryOptions"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          :errors-post="errorsPost.backupRecipients"
          :id="`${location}${index}backupRecipients`"
      />
      <ShareType
          v-if="backupRecipientsMoreThanOne"
          v-model="form.shareTypeBackup"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          type-location="shareTypeBackup"
          :id="`${location}${index}shareTypeBackup`"
      />
      <ShareSeparatePercentages
          v-if="form.shareTypeBackup === 'separate'"
          v-model="form.backupRecipients"
          :index="index"
          :no-save="noSave"
          :location="location"
          :gift-details="form"
          shareLocation="backupRecipients"
      />
    </div>
  </div>
</template>

<script>
import { giftRecipientHelpers } from "../../../question/questions/will/gifts/giftRecipientHelpers";

import IndexedYN from "../../../question/questions/will/gifts/sub/IndexedYN";
import ConditionYN from "../../../question/questions/will/gifts/sub/ConditionYN";
import CashAmount from "../../../question/questions/will/gifts/sub/CashAmount";
import Condition from "../../../question/questions/will/gifts/sub/Condition";
import TaxYN from "../../../question/questions/will/gifts/sub/TaxYN";
import StirpesYN from "../../../question/questions/will/gifts/sub/StirpesYN";
import StirpesAge from "../../../question/questions/will/gifts/sub/StirpesAge";
import CashText from "../../../question/questions/will/gifts/sub/CashText";
import Recipients from "../../../question/questions/will/gifts/sub/Recipients";
import RecipientsBackup from "../../../question/questions/will/gifts/sub/RecipientsBackup";
import RecipientsBackupYN from "../../../question/questions/will/gifts/sub/RecipientsBackupYN";
import ShareType from "../../../question/questions/will/gifts/sub/ShareType";
import ShareSeparatePercentages from "../../../question/questions/will/gifts/sub/ShareSeparatePercentages";

export default {
  name: 'GiftCash',
  components: {
    ShareSeparatePercentages,
    ShareType,
    RecipientsBackupYN,
    RecipientsBackup,
    Recipients, CashText, StirpesAge, StirpesYN, TaxYN, IndexedYN, Condition, ConditionYN, CashAmount},
  mixins: [giftRecipientHelpers],
  props: {
    value: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: false
    },
    noSave: {
      type: Boolean,
      default: false
    },
    errorsPost: {
      type: Object,
      default: () => {
        return {}
      }
    },
    location: {
      type: String,
      required: true
    }
  },
  computed: {
    form: {
      set(value) {
        this.$emit('input', value)
      },
      get() {
        return this.value
      }
    }
  }
}
</script>